import CheckList from "shared/assets/svgs/check-list.svg?react";
import Gears from "shared/assets/svgs/gears.svg?react";
import Notes from "shared/assets/svgs/notes.svg?react";
import { cn } from "shared/utils/cn";

import { Item } from "./item";

type Props = {
  className?: string;
};

export const NavBar = (props: Props) => {
  const { className } = props;
  return (
    <nav
      className={cn(
        "pb-safe sticky right-0 bottom-0 left-0 flex justify-between px-12 pt-3",
        className
      )}
    >
      <Item to="/tasks" icon={<CheckList />} title="My Tasks" />
      <Item to="/notes" icon={<Notes />} title="My Notes" />
      <Item to="/settings" icon={<Gears />} title="Settings" />
    </nav>
  );
};
